import React from 'react'
import { Image, TouchableOpacity, View } from 'react-native'

import { useHistory } from '@webstollen/react-native/lib/react-router'

import { IconName } from '@fortawesome/pro-solid-svg-icons'

import { FontAwesomeIcon } from '@webstollen/react-native/lib/fontawesome'

import SemiBoldText from '@webstollen/react-native/lib/components/CustomText/SemiBoldText'

import useStyles from './styles'

import { IShop } from '@dash.bar/types'
import ColoredText from '@webstollen/react-native/lib/components/CustomText/ColoredText'
import { useTranslation } from 'react-i18next'
import FavoriteButton from '../../../../layout/Header/FavoriteButton'
import icons from '../../../../constants/icons'

interface ShopItem extends IShop {
  path: string
  fontAwesomeIcon?: IconName
}

type Props = {
  shops: Array<ShopItem>
}

const ShopMenuItems = ({ shops }: Props) => {
  const history = useHistory()
  const { t } = useTranslation()
  const styles = useStyles()

  return (
    <>
      {shops.map(({ fontAwesomeIcon, icon, domain, path }) => (
        <View key={path} style={styles.wrapper}>
          <View style={styles.shopHeaderWrapper}>
            {fontAwesomeIcon ? (
              <View style={styles.iconBackground}>
                <FontAwesomeIcon style={styles.icon} icon={[icons.faIconStyle, fontAwesomeIcon]} />
              </View>
            ) : (
              <View style={styles.iconBackground}>
                <Image
                  style={styles.icon}
                  source={{
                    uri: icon,
                  }}
                  accessibilityLabel={domain}
                />
              </View>
            )}
            <SemiBoldText numberOfLines={1} style={[styles.name]}>
              {domain}
            </SemiBoldText>
            <View style={styles.iconWrapper}></View>
          </View>
          <View style={styles.shopItemsWrapper}>
            {[
              {
                path: `/shop/${domain}/live-tracker`,
                title: t('nav.live-tracker'),
              },
              {
                path: `/shop/${domain}/analytics`,
                title: t('nav.analytics'),
              },
              {
                path: `/shop/${domain}/orders`,
                title: t('nav.orders'),
              },
            ].map(({ path, title }) => (
              <TouchableOpacity onPress={() => history.push(path)} key={path}>
                <View style={styles.shopSubHeaderWrapper}>
                  <ColoredText style={styles.shopItems}>{title}</ColoredText>
                  <View>
                    <FavoriteButton url={path} title={title} subtitle={`${domain}`} />
                  </View>
                </View>
              </TouchableOpacity>
            ))}
          </View>
        </View>
      ))}
    </>
  )
}

export default ShopMenuItems
